import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { districtValidationForm } from "../../utils/validationSchemas";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import DistrictForm from "./DistrictForm";

const EditDistrict = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(districtValidationForm),
    defaultValues: async () => {
      let data: any = await props?.refetch();
      return {
        ...data?.data,
        country: data?.data?.state_name,
      };
    },
  });

  const { handleEdit, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <DistrictForm
        clearErrors={clearErrors}
        errors={errors}
        register={register}
        setValue={setValue}
        getValues={getValues}
      />
    </FormLayout>
  );
};

export default EditDistrict;
